import React from 'react'
import "./Breadcrumb.css";
import { Container } from "react-bootstrap";
import { useTranslation } from '../../../../contexts/TranslationContext';
import Cookies from 'js-cookie';



const Breadcrumb = ({ pageData , category,data}) => {
  const { t } = useTranslation();


    const Lang = Cookies.get("preferred_language") || "en";
  
  return (
    <div
      className="PackagesList-Breadcrumb-container"
      data-aos="fade"
      data-aos-duration="1000"
    >
      <Container>
        <div className="Breadcrumb-wrapper">
          <a className="Breadcrumb-link" href='/home'>{t("Home")}</a>
          <span className="Breadcrumb-separator">/</span>
          <span className="Breadcrumb-link">{t("Packages")}</span>
          {category && Lang !== "ar" && (
            <>
              <span className="Breadcrumb-separator">/</span>
              <span className="Breadcrumb-current">{category}</span>
            </>
          )}
        </div>
      </Container>
    </div>
  );
};

export default Breadcrumb;
